import { format, parseISO, isWithinInterval } from 'date-fns';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function AppointmentItem(props) {
  const { appointment, setSelectedAppointment, isSelected, blockedSlots } = props;

  // const isTimeBlocked = (date, appTime) => {
  //   const selectedTime = parseISO(`${date}T${appTime}`);

  //   for (const slot of blockedSlots) {
  //     const startTime = slot.date && slot.startTime ? parseISO(`${slot.date}T${slot.startTime}`) : '';
  //     const endTime = slot.date && slot.endTime ? parseISO(`${slot.date}T${slot.endTime}`) : '';

  //     // if (startTime && endTime ? isWithinInterval(selectedTime, { start: startTime, end: endTime }) : false) {
  //     //   return true;
  //     // }

  //   if (isWithinInterval(selectedTime, { start: startTime, end: endTime })) {
  //     return true;
  //   }
  //   }

  //   return false;
  // };

  const isTimeBlocked = (date, appTime) => {
    try {
      const selectedTime = parseISO(`${date}T${appTime}`);
  
      for (const slot of blockedSlots) {
        if (!slot.date || !slot.startTime || !slot.endTime) continue;
  
        const start = parseISO(`${slot.date}T${slot.startTime}`);
        const end = parseISO(`${slot.date}T${slot.endTime}`);
  
        if (isNaN(start) || isNaN(end) || isNaN(selectedTime)) continue;
  
        if (isWithinInterval(selectedTime, { start, end })) {
          return true;
        }
      }
  
      return false;
    } catch (error) {
      console.error("Error in isTimeBlocked:", error);
      return false;
    }
  };
  
  let startDateTime = parseISO(`${appointment.date}T${appointment.appTime}`);
//  console.log(setSelectedAppointment)
  const _onViewDetails = () => {
    
    setSelectedAppointment(appointment);
  };

  return (
    // <li onClick={_onViewDetails} className={classNames(isSelected ? 'active' : '', isTimeBlocked(appointment.date, appointment.appTime) ? 'cursor-not-allowed pointer-events-none border border-red-400' : 'border border-blue-400')}>
    //   {/* In case someday users have avatars */}
    //   {/*<img src={meeting.imageUrl} alt="" className="flex-none w-10 h-10 rounded-full" />*/}
    //   <div className="flex-auto">
    //     {/* <span>{appointment.userFullName}</span> */}
    //     <p className="mt-0.5">
    //       <time className={classNames(isTimeBlocked(appointment.date, appointment.appTime) ? 'text-red-500' : '')} dateTime={startDateTime}>
    //         {format(startDateTime, 'h:mm a')}
    //       </time>
    //     </p>
    //   </div>
    // </li>
    // <div className="time-slots">
    //     {timeSlots.map((time) => (
      <>
     {!isTimeBlocked(appointment.date, appointment.appTime) && (
  <button
    key={appointment.appTime}
    className={classNames(
      isSelected ? 'selected' : '',
      'time-slot border',
      isTimeBlocked(appointment.date, appointment.appTime)
        ? 'cursor-not-allowed pointer-events-none border-red-400'
        : 'border-blue-400'
    )}
    onClick={_onViewDetails}
  >
    {format(startDateTime, 'h:mm a')}
  </button>
)}

      
      </>
      //   ))}
      // </div>
  );
}
